import { monthEndAlertConstants } from '../../actions/constant';

const { SUCCESS_CERTIFY_ALERT, FAILURE_CERTIFY_ALERT, LOADING_CERTIFY_ALERT, RESET_CERTIFY_ALERT } =
  monthEndAlertConstants;

const intitialstate: object = {
  response: null,
  isCertify: false,
  loading: false,
};

export const certifyMonthEndAlertReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_CERTIFY_ALERT: {
      return {
        ...state,
        isCertify: true,
        response: action.payload,
        loading: false,
      };
    }

    case FAILURE_CERTIFY_ALERT:
      return {
        ...state,
        isCertify: false,
        response: action.payload,
        loading: false,
      };

    case RESET_CERTIFY_ALERT:
      return intitialstate;

    case LOADING_CERTIFY_ALERT:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
